import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://ymytutoring.com/api/client';

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');

  const publicRoutes = ['/public', '/auth'];
  const isPublic = publicRoutes.some(route => config.url?.startsWith(route));

  if (token && !isPublic) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});
